import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import SemanaComponent from './SemanaComponent';
import Dia from './Dia';
import estilos from './Calendario.module.css'

function MesComponent(props) {

    const [visitasMes, setVisitasMes] = React.useState([])
    const semanas = props.semanas
    const anios = [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035]
    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    const nombres = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado']

    React.useEffect(() => {
        //console.log('Empezando Mes')
        setVisitasMes([])
        setVisitasMes(props.visitasMes)
    }, [props.visitasMes, props.mes])

    React.useEffect(() => {
        visitasMes
    }, [visitasMes])

    const generarSemanas = (dias, empieza) => {
        let content = [];
        let contador = -1;
        let bandera = false;
        //FOR PARA LAS SEMANAS
        for (let i = 1; i <= 6; i++) {
            //FOR PARA LOS DÍAS
            for (let x = 1; x <= 7; x++) {
                if (x === empieza) {
                    contador = contador + 1;
                    let visitasDia = []
                    visitasMes.map((visita) => {
                        let fecha = new Date(visita.fecharealdeinspeccion)
                        if (fecha.getDate() == contador && meses[fecha.getMonth()] == props.mes && fecha.getFullYear() == props.ano) {
                            visitasDia.push(visita)
                        }
                    })
                    content.push(<div key={contador + x + 'i' + i} className={`col-md-1 ${estilos.col_md_1especial}`}>
                        <Dia visitasDia={visitasDia}
                            handleModal={props.handleModal}
                            ano={props.ano} mes={props.mes}
                            numeroDeDia={contador + 1}
                            indexDiaDeLaSemana={x + 1}
                            semana={semanas[i - 1]}
                            zona={props.zona}>
                        </Dia></div>);
                    bandera = true;
                } else if (bandera === true) {
                    contador = contador + 1;
                    let visitasDia = []
                    visitasMes.map((visita) => {
                        let fecha = new Date(visita.fecharealdeinspeccion)
                        if (fecha.getDate() == contador && meses[fecha.getMonth()] == props.mes && fecha.getFullYear() == props.ano) {
                            visitasDia.push(visita)
                        }
                    })
                    content.push(<div key={contador + x + 'x'} className={`col-md-1 ${estilos.col_md_1especial}`}>
                        <Dia visitasDia={visitasDia}
                            handleModal={props.handleModal}
                            ano={props.ano} mes={props.mes}
                            numeroDeDia={contador + 1}
                            indexDiaDeLaSemana={x + 1}
                            semana={semanas[i - 1]}
                            zona={props.zona}>
                        </Dia>
                    </div>);

                }
                else {
                    content.push(<div key={contador + 'x' + 'i' + x} className={`col-md-1 ${estilos.col_md_1especial}`}></div>);
                }
                if (contador === dias) { break; }
            }
            if (contador === dias) { break; }
        }
        return content;
    };


    return (
        <Fragment>
            <div className={`row ${estilos.seven_cols}`} key={1}>
                <div className="col" style={{ textAlign: 'center', textTransform: 'uppercase', fontSize: '14px', backgroundColor: 'orange', color: 'white', fontWeight: 'bold' }}>
                    Domingo
                </div>
                <div className="col" style={{ textAlign: 'center', textTransform: 'uppercase', fontSize: '14px', backgroundColor: 'orange', color: 'white', fontWeight: 'bold' }}>
                    Lunes
                </div>
                <div className="col" style={{ textAlign: 'center', textTransform: 'uppercase', fontSize: '14px', backgroundColor: 'orange', color: 'white', fontWeight: 'bold' }}>
                    Martes
                </div>
                <div className="col" style={{ textAlign: 'center', textTransform: 'uppercase', fontSize: '14px', backgroundColor: 'orange', color: 'white', fontWeight: 'bold' }}>
                    Miercoles
                </div>
                <div className="col" style={{ textAlign: 'center', textTransform: 'uppercase', fontSize: '14px', backgroundColor: 'orange', color: 'white', fontWeight: 'bold' }}>
                    Jueves
                </div>
                <div className="col" style={{ textAlign: 'center', textTransform: 'uppercase', fontSize: '14px', backgroundColor: 'orange', color: 'white', fontWeight: 'bold' }}>
                    Viernes
                </div>
                <div className="col" style={{ textAlign: 'center', textTransform: 'uppercase', fontSize: '14px', backgroundColor: 'orange', color: 'white', fontWeight: 'bold' }}>
                    Sabado
                </div>
            </div>
            <div className={`row ${estilos.seven_cols}`}>
                {generarSemanas(props.dias, props.empieza)}
            </div>
            <br />
        </Fragment>
    );
};


export default withRouter(MesComponent)
